export class DemoData {
    ficoScore?: number;
    firstName?: string;
    lastName?: string;
    dateOfBirth?: {
        month?: number;
        day?: number;
        year?: number;
    };
    emailAddress?: string;
    address?: string;
    phoneNumber?: string;
    rentMortgage?: number;
    lengthAtAddress?: number;
    lengthAtJob?: number;
    monthlyGrossIncome?: number;
    preferredLoanAmount?: number;
    preferredDownPayment?: number;
    preferredMonthlyPayment?: number;
}

export const TESTFICO: DemoData[] = [
    {
        'ficoScore': 0,
        'firstName': 'Jon',
        'lastName': 'Consumer',
        'dateOfBirth': { 'month': 1, 'day': 12, 'year': 1951 },
        'emailAddress': 'jonconsumer@nowcom.com',
        'address': '4751 wilshire blvd, los angeles,CA, 90010, USA',
        'phoneNumber': '(555) 555-5555',
        'rentMortgage': 350,
        'lengthAtAddress': 3.5,
        'lengthAtJob': 2.5,
        'monthlyGrossIncome': 15000,
        'preferredLoanAmount': 20000,
        'preferredDownPayment': 5000,
        'preferredMonthlyPayment': 500
    },
    {
        'ficoScore': 507,
        'firstName': '__NOWCOM',
        'lastName': '999912356',
        'dateOfBirth': { 'month': 9, 'day': 25, 'year': 1956 },
        'emailAddress': 'jonconsumer@nowcom.com',
        'address': '4751 wilshire blvd, los angeles,CA, 90010, USA',
        'phoneNumber': '(626) 652-2288',
        'rentMortgage': 350,
        'lengthAtAddress': 3.5,
        'lengthAtJob': 2.5,
        'monthlyGrossIncome': 15000,
        'preferredLoanAmount': 20000,
        'preferredDownPayment': 5000,
        'preferredMonthlyPayment': 500
    },
    {
        'ficoScore': 537,
        'firstName': '__NOWCOM',
        'lastName': '999912340',
        'dateOfBirth': { 'month': 9, 'day': 25, 'year': 1956 },
        'emailAddress': 'jonconsumer@nowcom.com',
        'address': '4751 wilshire blvd, los angeles,CA, 90010, USA',
        'phoneNumber': '(626) 652-2288',
        'rentMortgage': 350,
        'lengthAtAddress': 3.5,
        'lengthAtJob': 2.5,
        'monthlyGrossIncome': 15000,
        'preferredLoanAmount': 20000,
        'preferredDownPayment': 5000,
        'preferredMonthlyPayment': 500
    },
    {
        'ficoScore': 562,
        'firstName': '__NOWCOM',
        'lastName': '999912344',
        'dateOfBirth': { 'month': 9, 'day': 25, 'year': 1956 },
        'emailAddress': 'jonconsumer@nowcom.com',
        'address': '4751 wilshire blvd, los angeles,CA, 90010, USA',
        'phoneNumber': '(626) 652-2288',
        'rentMortgage': 350,
        'lengthAtAddress': 3.5,
        'lengthAtJob': 2.5,
        'monthlyGrossIncome': 15000,
        'preferredLoanAmount': 20000,
        'preferredDownPayment': 5000,
        'preferredMonthlyPayment': 500
    },
    {
        'ficoScore': 567,
        'firstName': '__NOWCOM',
        'lastName': '999912347',
        'dateOfBirth': { 'month': 9, 'day': 25, 'year': 1956 },
        'emailAddress': 'jonconsumer@nowcom.com',
        'address': '4751 wilshire blvd, los angeles,CA, 90010, USA',
        'phoneNumber': '(626) 652-2288',
        'rentMortgage': 350,
        'lengthAtAddress': 3.5,
        'lengthAtJob': 2.5,
        'monthlyGrossIncome': 15000,
        'preferredLoanAmount': 20000,
        'preferredDownPayment': 5000,
        'preferredMonthlyPayment': 500
    },
    {
        'ficoScore': 610,
        'firstName': '__NOWCOM',
        'lastName': '999912355',
        'dateOfBirth': { 'month': 9, 'day': 25, 'year': 1956 },
        'emailAddress': 'jonconsumer@nowcom.com',
        'address': '4751 wilshire blvd, los angeles,CA, 90010, USA',
        'phoneNumber': '(626) 652-2288',
        'rentMortgage': 350,
        'lengthAtAddress': 3.5,
        'lengthAtJob': 2.5,
        'monthlyGrossIncome': 15000,
        'preferredLoanAmount': 20000,
        'preferredDownPayment': 5000,
        'preferredMonthlyPayment': 500
    },
    {
        'ficoScore': 616,
        'firstName': '__NOWCOM',
        'lastName': '999912348',
        'dateOfBirth': { 'month': 9, 'day': 25, 'year': 1956 },
        'emailAddress': 'jonconsumer@nowcom.com',
        'address': '4751 wilshire blvd, los angeles,CA, 90010, USA',
        'phoneNumber': '(626) 652-2288',
        'rentMortgage': 350,
        'lengthAtAddress': 3.5,
        'lengthAtJob': 2.5,
        'monthlyGrossIncome': 15000,
        'preferredLoanAmount': 20000,
        'preferredDownPayment': 5000,
        'preferredMonthlyPayment': 500
    },
    {
        'ficoScore': 644,
        'firstName': '__NOWCOM',
        'lastName': '999912342',
        'dateOfBirth': { 'month': 9, 'day': 25, 'year': 1956 },
        'emailAddress': 'jonconsumer@nowcom.com',
        'address': '4751 wilshire blvd, los angeles,CA, 90010, USA',
        'phoneNumber': '(626) 652-2288',
        'rentMortgage': 350,
        'lengthAtAddress': 3.5,
        'lengthAtJob': 2.5,
        'monthlyGrossIncome': 15000,
        'preferredLoanAmount': 20000,
        'preferredDownPayment': 5000,
        'preferredMonthlyPayment': 500
    },
    {
        'ficoScore': 671,
        'firstName': '__NOWCOM',
        'lastName': '999912350',
        'dateOfBirth': { 'month': 9, 'day': 25, 'year': 1956 },
        'emailAddress': 'jonconsumer@nowcom.com',
        'address': '4751 wilshire blvd, los angeles,CA, 90010, USA',
        'phoneNumber': '(626) 652-2288',
        'rentMortgage': 350,
        'lengthAtAddress': 3.5,
        'lengthAtJob': 2.5,
        'monthlyGrossIncome': 15000,
        'preferredLoanAmount': 20000,
        'preferredDownPayment': 5000,
        'preferredMonthlyPayment': 500
    },
    {
        'ficoScore': 680,
        'firstName': '__NOWCOM',
        'lastName': '999912354',
        'dateOfBirth': { 'month': 9, 'day': 25, 'year': 1956 },
        'emailAddress': 'jonconsumer@nowcom.com',
        'address': '4751 wilshire blvd, los angeles,CA, 90010, USA',
        'phoneNumber': '(626) 652-2288',
        'rentMortgage': 350,
        'lengthAtAddress': 3.5,
        'lengthAtJob': 2.5,
        'monthlyGrossIncome': 15000,
        'preferredLoanAmount': 20000,
        'preferredDownPayment': 5000,
        'preferredMonthlyPayment': 500
    },
    {
        'ficoScore': 700,
        'firstName': '__NOWCOM',
        'lastName': '999912354',
        'dateOfBirth': { 'month': 9, 'day': 25, 'year': 1956 },
        'emailAddress': 'jonconsumer@nowcom.com',
        'address': '4751 wilshire blvd, los angeles,CA, 90010, USA',
        'phoneNumber': '(626) 652-2288',
        'rentMortgage': 350,
        'lengthAtAddress': 3.5,
        'lengthAtJob': 2.5,
        'monthlyGrossIncome': 15000,
        'preferredLoanAmount': 20000,
        'preferredDownPayment': 5000,
        'preferredMonthlyPayment': 500
    },
    {
        'ficoScore': 720,
        'firstName': '__NOWCOM',
        'lastName': '999912343',
        'dateOfBirth': { 'month': 9, 'day': 25, 'year': 1956 },
        'emailAddress': 'jonconsumer@nowcom.com',
        'address': '4751 wilshire blvd, los angeles,CA, 90010, USA',
        'phoneNumber': '(626) 652-2288',
        'rentMortgage': 350,
        'lengthAtAddress': 3.5,
        'lengthAtJob': 2.5,
        'monthlyGrossIncome': 15000,
        'preferredLoanAmount': 20000,
        'preferredDownPayment': 5000,
        'preferredMonthlyPayment': 500
    },
    {
        'ficoScore': 770,
        'firstName': '__NOWCOM',
        'lastName': '999912341',
        'dateOfBirth': { 'month': 9, 'day': 25, 'year': 1956 },
        'emailAddress': 'jonconsumer@nowcom.com',
        'address': '4751 wilshire blvd, los angeles,CA, 90010, USA',
        'phoneNumber': '(626) 652-2288',
        'rentMortgage': 350,
        'lengthAtAddress': 3.5,
        'lengthAtJob': 2.5,
        'monthlyGrossIncome': 15000,
        'preferredLoanAmount': 20000,
        'preferredDownPayment': 5000,
        'preferredMonthlyPayment': 500
    },
    {
        'ficoScore': 779,
        'firstName': '__NOWCOM',
        'lastName': '999912345',
        'dateOfBirth': { 'month': 9, 'day': 25, 'year': 1956 },
        'emailAddress': 'jonconsumer@nowcom.com',
        'address': '4751 wilshire blvd, los angeles,CA, 90010, USA',
        'phoneNumber': '(626) 652-2288',
        'rentMortgage': 350,
        'lengthAtAddress': 3.5,
        'lengthAtJob': 2.5,
        'monthlyGrossIncome': 15000,
        'preferredLoanAmount': 20000,
        'preferredDownPayment': 5000,
        'preferredMonthlyPayment': 500
    },
    {
        'ficoScore': 798,
        'firstName': '__NOWCOM',
        'lastName': '999912353',
        'dateOfBirth': { 'month': 9, 'day': 25, 'year': 1956 },
        'emailAddress': 'jonconsumer@nowcom.com',
        'address': '4751 wilshire blvd, los angeles,CA, 90010, USA',
        'phoneNumber': '(626) 652-2288',
        'rentMortgage': 350,
        'lengthAtAddress': 3.5,
        'lengthAtJob': 2.5,
        'monthlyGrossIncome': 15000,
        'preferredLoanAmount': 20000,
        'preferredDownPayment': 5000,
        'preferredMonthlyPayment': 500
    },
    {
        'ficoScore': 820,
        'firstName': '__NOWCOM',
        'lastName': '999912351',
        'dateOfBirth': { 'month': 9, 'day': 25, 'year': 1956 },
        'emailAddress': 'jonconsumer@nowcom.com',
        'address': '4751 wilshire blvd, los angeles,CA, 90010, USA',
        'phoneNumber': '(626) 652-2288',
        'rentMortgage': 350,
        'lengthAtAddress': 3.5,
        'lengthAtJob': 2.5,
        'monthlyGrossIncome': 15000,
        'preferredLoanAmount': 20000,
        'preferredDownPayment': 5000,
        'preferredMonthlyPayment': 500
    }

];


// WEBPACK FOOTER //
// ./src/app/shared/components/demo-mode/demo-ficoscores.ts